<template lang="pug">
section
  TabsMenu(
    :current="current"
    :items="menu"
    @change="onChange"
  )
  slot(
    :currentView="currentComponent"
    :currentProps="currentTab"
  )
</template>

<script>
import TabsMenu from '../menu';

export default {
  components: {
    TabsMenu,
  },

  props: {
    tabs: {
      type: Array,
      default: () => [],
    },

    currentComponent: {
      type: String,
      default: '',
    },
  },

  data: () => ({ currentTab: null }),

  computed: {
    menu() {
      return this.tabs.map((item) => ({ ...item, after: item.count }));
    },

    current() {
      const { currentComponent, tabs } = this;
      return tabs.findIndex(({ component }) => component === currentComponent);
    },
  },

  watch: {
    tabs: {
      handler: 'setProp',
      immediate: true,
    },

    currentComponent: 'setProp',
  },

  methods: {
    onChange(index) {
      const { tabs } = this;
      if (!index in tabs) return;
      this.setTab(tabs[index]);
    },

    setProp() {
      const { currentComponent, tabs } = this;
      tabs.map(({ component, props }) => {
        if (component === currentComponent) this.currentTab = props;
      });
    },

    setTab(tab) {
      this.currentTab = tab.props;
      this.$emit('tab-changed', tab.component);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/stylus/helpers/mediaqueriesStep'

.tabs
  padding 0
  margin 0
  list-style-type none
  margin-bottom 25px
  border-bottom 1px solid #d3d4d9
  display flex
  flex-direction column
  align-items flex-start

  +tablet-768-plus()
    flex-direction row

  &__item
    text-transform uppercase
    margin-left 0
    margin-bottom 16px
    padding-bottom 4px
    border-bottom 2px solid transparent
    font-weight 700
    font-size 14px
    color: rgba(0, 0, 0, 0.85)
    cursor pointer
    transition border-color .3s ease

    &:hover,
    &.current {
      border-color #8163a6
    }

    &:first-child {
      margin-left 0
    }

    +tablet-768-plus()
      margin-left 32px
      margin-bottom -2px
      padding-bottom 11px

  &__counter
    font-size 14px
    line-height 1
    display inline-block
    vertical-align bottom
    font-style normal
    color #e34b4b
    margin-left 5px
</style>



// WEBPACK FOOTER //
// Tabs.vue?b908680a